import { Component, OnInit } from '@angular/core';
import { Candidate } from '../../candidate';
import { AuthService } from '../../auth.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { SharedService } from 'src/app/shared.service';
@Component({
  selector: 'app-candidate-sign-up',
  templateUrl: './candidate-sign-up.component.html',
  styleUrls: ['./candidate-sign-up.component.css']
})
export class CandidateSignUpComponent implements OnInit {

  email = '';
  password;
  cnfPassword
  candidate_details: Candidate = {
    role:'candidate',
    profile:{
      first_name: '',
      last_name: '',
      email_id: '',
    }    
  }
  checker: boolean =  false;

  constructor(private auth: AuthService, private router: Router, private _snackBar: MatSnackBar, private sharedService: SharedService) { }

  ngOnInit() {
  }

  onChange(event){
    this.candidate_details.profile.first_name = String(this.candidate_details.profile.first_name).trim().replace(/\s\s+/g, ' ');
    this.candidate_details.profile.last_name = String(this.candidate_details.profile.last_name).trim().replace(/\s\s+/g, ' ');
    this.email = String(this.email).trim().replace(/\s\s+/g, ' '); 
  }

  onSubmit() {
    if (this.candidate_details.profile.first_name && this.candidate_details.profile.last_name && this.email) {
      if(this.password === this.cnfPassword){
        if(this.checker == true){
          localStorage.setItem('role',this.candidate_details.role)
          localStorage.setItem('first_name',this.candidate_details.profile.first_name);
          localStorage.setItem('last_name',this.candidate_details.profile.last_name);
          localStorage.setItem('email_id',this.email);
          this.sharedService.updatedisplayName(this.candidate_details.profile.first_name)
          this.candidate_details.profile.email_id = this.email;
          this.auth.candidateSignUp(this.email, this.password, this.candidate_details).then(
            (data) => {
              console.log(data)
              localStorage.setItem('user',JSON.stringify(data))
              this.auth.sendMail(this.email).subscribe((a)=>{
                console.log("mail send")
              },(error) => {
                console.log("mail not send")
              })           
              this.router.navigate(['/create-profile']);
            }
          ).catch(
            (error) => {
              console.log(error)
              this._snackBar.open(error.message, 'Okay', {
                duration: 5000,
              });
            }
          )
        } else{
          this._snackBar.open('Please accept T & C', 'Okay',{
            duration: 5000,
          });
        }
      }
      else{
        this._snackBar.open('Check confirm password', 'Okay', {
          duration: 5000,
        });
      }     
    }
    else{
      this._snackBar.open('Please fill all details', 'Okay', {
        duration: 5000,
      });
    }

  }

}
